'use strict';
import $ from 'jquery';

export default class GnarlyDataWaves {
    static init() {
        $('.cat-list_item').each((index, el) => {
            new GnarlyDataWaves($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.on('click', (e) => {
            e.preventDefault();
            const term = this.el.data('term_slug');
            $('.cat-list_item').removeClass('current');
            this.el.addClass('current');
            $('.event-list-tab').removeClass('active');
            $('.event-list-tab[data-term_slug=' + term + ']').addClass('active');
        });
    }
}